// src/store/meetingRoomSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  resetKey: 0,
};

const meetingRoomSlice = createSlice({
  name: 'meetingRoom',
  initialState,
  reducers: {
    triggerReset(state) {
      // Incrementing the key forces any subscribers to re-run their useEffect
      state.resetKey += 1;
    },
  },
});

export const { triggerReset } = meetingRoomSlice.actions;
export default meetingRoomSlice.reducer;
